import React, { useState, useEffect, useRef } from "react";
import { Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import uRLs from "../../../utils/baseUtils";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import Messages from "../../../constants/Messages";
import handleError from "../../../constants/handleError";

import AddSubStore from "./AddSubStore";
import AddHubStore from "./AddHubStore";
import DeleteModal from "../../../constants/DeleteModal";
import { AddIcon, LoaderAltIcon, LogInCircleIcon, PlusIcon, SearchIcon, TelegramIcon, TrashIcon } from "../../../constants/Icons";

const Store = () => {

    const [isBtnLoading, setBtnLoading] = useState(null);
    const [isHubLoading, setSubLoading] = useState(null);
    const [isSubLoading, setHubLoading] = useState(null);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isHubModelOpen, setHubModelOpen] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [invitedShop, setInvitedShop] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedId, setSelectedId] = useState(null);

    const { checkNetwork } = useNetwork();
    const showAlert = useShowAlert();
    const navigate = useNavigate();

    const getColor = (status) => {
        switch (status?.toLowerCase()) {
            case "invited": return "bg-label-bird";
            case "active": return "bg-label-success";
            case "accepted": return "bg-label-success";
            case "pending": return "bg-label-danger";
            default: return "bg-label-secondary";
        }
    };

    const handleOpenModal = () => setModalOpen(true);
    const handleCloseModal = () => setModalOpen(false);
    const handleOpenHub = () => setHubModelOpen(true);
    const handleCloseHub = () => setHubModelOpen(false);
    
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isSelectedStore, setSelectedStore] = useState(null);


    const fetchShopsData = async () => {
        try {
            if (!checkNetwork()) return;
            const response = await AxiosInstance.get(`list-invite-store`);
            const results = response.data.results;
            if (results && results.length > 0) {
                setInvitedShop(results);
                setFilteredData(results)
            }
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    const handleResendSubInvite = async (verifyid) => {
        setSubLoading(verifyid);
        try {
            if (!checkNetwork()) return;
            const response = await AxiosInstance.post(`resend-substore-invite`, { verifyid });
            setSubLoading(null);
            showAlert("success", Messages.SUCCESS.INVITATION_RESEND);
        } catch (err) {
            setSubLoading(null);
            handleError(err, showAlert);
            return false;

        }
    };

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        const filtered = invitedShop.filter((shop) => {
            const matchesMainShop =
                shop.title?.toLowerCase().includes(query) ||
                shop.stype?.toLowerCase().includes(query) ||
                shop.email?.toLowerCase().includes(query);

            const matchesHubStore = shop.subInfo?.hubStore?.some((hub) =>
                hub.title?.toLowerCase().includes(query) ||
                hub.stype?.toLowerCase().includes(query) ||
                hub.email?.toLowerCase().includes(query)
            );

            return matchesMainShop || matchesHubStore;
        });

        setFilteredData(filtered);
    };

    const handleResendhubInvite = async (verifyid) => {
        setHubLoading(verifyid);
        try {
            if (!checkNetwork()) return;
            const response = await AxiosInstance.post(`resend-hubstore-invite`, { verifyid });
            setHubLoading(null);
            showAlert("success", Messages.SUCCESS.INVITATION_RESEND);
        } catch (err) {
            setHubLoading(null);
            handleError(err, showAlert);
            return false;
        }
    };

    const openDeleteModal = (productId) => {
        setSelectedStore(productId);
        setDeleteModalOpen(true);
    };

    const handleDelete = async () => {
        setBtnLoading(true);
        try {
            if (!checkNetwork()) return;
            const data = { inviteid: isSelectedStore._id };
            await AxiosInstance.post(`delete-invite`, data);
            const updatedProducts = invitedShop.filter(
                (shop) => shop._id !== isSelectedStore._id
            );
            setInvitedShop(updatedProducts);
            setFilteredData(updatedProducts);
            showAlert("success", Messages.SUCCESS.STORE_DELETED);
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } finally {
            closeDeleteModal();
            setBtnLoading(false);
        }
    };

    const closeDeleteModal = () => {
        setDeleteModalOpen(false);
        setSelectedStore(null);
    };

    const openLogin = async (storeid) => {
        try {
            if (!checkNetwork()) return;
            const data = { storeid: storeid };
            const respon = await AxiosInstance.post(`create-store-token`, data);
            window.open(`${uRLs.LOGIN_URL}access-store/${respon.data.results.accessToken}/${respon.data.results.refreshToken}`, '_blank');
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchShopsData();
    }, [isModalOpen, isHubModelOpen, isDeleteModalOpen]);

    return (
        <div className="page-wrapper">
            <div className="page-content">
                <div className="page-breadcrumb d-flex align-items-center mb-3">
                    <div className="breadcrumb-title pe-3">Manage Outlet</div>
                    {/* <div className="ms-auto">
                        <button type="button" className="btn btn-primary mt-2 mt-lg-0" onClick={handleOpenModal}>
                            <i className="ng ng-ng-add-icon"></i> New Outlet
                        </button>
                    </div> */}
                </div>

                <div className="row">
                    <div className="col">
                        <div className="card radius-10 mb-0">
                            <div className="card-body px-0">
                                <div className="row px-3">
                                    <div className="col-lg-5 me-auto">
                                        <div className="position-relative">
                                            <div className="input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search sub and hub account by title, email, etc..."
                                                    value={searchQuery}
                                                    onChange={handleSearch}
                                                    autoFocus
                                                />
                                                <button className="input-group-text">
                                                    <SearchIcon/>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-7 ms-auto d-flex justify-content-end">
                        <button type="button" className="btn btn-primary mt-2 mt-lg-0" onClick={handleOpenModal}>
                            <AddIcon/> New Outlet
                        </button>
                    </div>
                                </div>

                                <div className="table-responsive mt-3">
                                    <table className="table align-middle mb-0">
                                        <thead className="table-light text-center">
                                            <tr>
                                                <th>S.No</th>
                                                <th>Store Type</th>
                                                <th>Title</th>
                                                <th>Email</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? (
                                                [...Array(8)].map((_, index) => (
                                                    <tr key={index}>
                                                        <td className="text-center">
                                                            <Skeleton variant="text" width={50} />
                                                        </td>
                                                        <td className="text-center">
                                                            <Skeleton variant="text" width={250} />
                                                        </td>
                                                        <td className="text-center">
                                                            <Skeleton variant="text" width={250} />
                                                        </td>
                                                        <td className="text-center">
                                                            <Skeleton variant="text" width={250} />
                                                        </td>
                                                        <td className="text-center">
                                                            <Skeleton variant="text" width={250} />
                                                        </td>
                                                        <td className="text-center">
                                                            <Skeleton variant="text" width={200} />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : filteredData.length > 0 ? (
                                                filteredData.map((item, index) => (
                                                    <React.Fragment key={item._id || index}>
                                                        <tr className="bg-sub">
                                                            <td className="text-center">
                                                                {index + 1}
                                                            </td>
                                                            <td className="text-center">
                                                                <span className="badge bg-label-peach rounded-pill"> {item.stype}</span>
                                                            </td>
                                                            <td className="text-center">
                                                                <span className="fw-semibold">
                                                                    {item.title}
                                                                </span>
                                                            </td>
                                                            <td className="text-center" width="480">
                                                                <span className="text-heading fw-medium text-truncate">
                                                                    {item.email}
                                                                </span>
                                                            </td>

                                                            <td className="text-center">
                                                                <span className={`badge rounded-pill ${getColor(item.status)}`}>
                                                                    {(item.status === "ACCEPTED" || item.status === "ACTIVE")
                                                                        ? "Active"
                                                                        : item.status === "PENDING"
                                                                            ? "pending"
                                                                            : item.status === "INVITED"
                                                                                ? "Invited"
                                                                                : ""}
                                                                </span>
                                                            </td>
                                                            <td className="text-center">
                                                                {item.status.toLocaleLowerCase() ===
                                                                    "accepted" ? (
                                                                    <div className="order_actions">
                                                                        {/* <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-hub shadow-none me-2"
                                                                            onClick={() => {
                                                                                setSelectedId(item.subInfo?._id);
                                                                                handleOpenHub();
                                                                            }}>
                                                                            <i className="ng ng-ng-add-icon"></i>
                                                                            <span> Hub </span>
                                                                        </button> */}

                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-dark btn-sm shadow-none me-2"
                                                                            onClick={() => openLogin(item?.subInfo?._id)}>
                                                                            Login <LogInCircleIcon/>
                                                                        </button>
                                                                    </div>
                                                                ) : item.status.toLocaleLowerCase() ===
                                                                    "invited" ? (
                                                                    <div className="d-flex justify-content-center">
                                                                        <div className="order_actions ">
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-label-wave btn-sm shadow-none me-2"
                                                                                onClick={() => handleResendSubInvite(item._id)}
                                                                                disabled={isHubLoading === item._id} >
                                                                                {isHubLoading === item._id ? (
                                                                                    <LoaderAltIcon iClass={"bx-spin"}/>
                                                                                ) : (
                                                                                    <>
                                                                                        <TelegramIcon iClass={"fs-6"}/>
                                                                                        <span> Resend </span>
                                                                                    </>
                                                                                )}

                                                                            </button>
                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-label-danger btn-sm shadow-none me-2"
                                                                                onClick={() => openDeleteModal(item)} >
                                                                                <TrashIcon iClass={"fs-6"}/>
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    ""
                                                                )}
                                                            </td>
                                                        </tr>
                                                        {item?.subInfo?.hubStore &&
                                                            item?.subInfo?.hubStore?.length > 0 &&
                                                            item?.subInfo?.hubStore?.map((hub, hubIndex) => (
                                                                <tr className="bg-hub">
                                                                    <td className="text-center">
                                                                        {hubIndex + 1}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span className="badge  bg-label-night rounded-pill"> {hub.stype} </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span className="">{hub.title}</span>
                                                                    </td>
                                                                    <td className="text-center" width="480">
                                                                        <span className="text-heading fw-medium text-truncate">
                                                                            {hub.email}
                                                                        </span>
                                                                    </td>

                                                                    <td className="text-center">
                                                                        <span
                                                                            className={`badge rounded-pill ${getColor(hub.status)}`}>
                                                                            {hub.status === "ACCEPTED"
                                                                                ? "Active"
                                                                                : hub.status === "PENDING"
                                                                                    ? "pending"
                                                                                    // : hub.status === "ACCEPTED"
                                                                                    // ? "Accepetd"
                                                                                    : hub.status === "INVITED"
                                                                                        ? "Invited"
                                                                                        : ""
                                                                            }
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        {hub.status.toLocaleLowerCase() ===
                                                                            "accepted" ? (
                                                                            <div className="order_actions">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-dark btn-sm shadow-none me-2"
                                                                                    onClick={() => openLogin(hub?.hubInfo?._id)}>
                                                                                    <span> Login </span> <LogInCircleIcon/>
                                                                                </button>
                                                                            </div>
                                                                        ) : hub.status.toLocaleLowerCase() ===
                                                                            "invited" ? (
                                                                            <div className="d-flex justify-content-center">
                                                                                <div className="order_actions">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-label-wave btn-sm shadow-none me-2"
                                                                                        onClick={() => handleResendhubInvite(hub._id)}
                                                                                        disabled={isSubLoading === hub._id} >
                                                                                        {isSubLoading === hub._id ? (
                                                                                            <LoaderAltIcon iClass={"bx spin"}/>
                                                                                        ) : (
                                                                                            <>
                                                                                                <TelegramIcon/>
                                                                                                <span> Resend </span>
                                                                                            </>
                                                                                        )}

                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-label-danger btn-sm shadow-none me-2"
                                                                                        onClick={() => openDeleteModal(hub)}>
                                                                                        <TrashIcon iClass={"fs-6"}/>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                    </React.Fragment>
                                                ))
                                            ) : (
                                                <>
                                                    <tr>
                                                        <td colSpan="6" className="text-center p-2">
                                                            <span className="text-muted">
                                                                No sub/hub store found in the account. add some store to get started.
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>

                                                        <td colSpan="6" className="text-center p-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary mt-4 mt-lg-0"
                                                                onClick={handleOpenModal}>
                                                                <PlusIcon/> Add
                                                                Sub Store
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AddSubStore
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                />

                <AddHubStore
                    isOpen={isHubModelOpen}
                    onClose={handleCloseHub}
                    selectedId={selectedId}
                />
                {isDeleteModalOpen && (
                    <DeleteModal
                        isOpen={isDeleteModalOpen}
                        onConfirm={handleDelete}
                        onClose={closeDeleteModal}
                        isLable={" Store " + isSelectedStore?.title}
                        isBtnLoading={isBtnLoading}
                    />
                )}
            </div>
        </div>
    );
};

export default Store;